import React, {useEffect, useState} from 'react';
import {Button, Paper, Stack} from "@mui/material";
import {baseUrl_back} from "../../api/BaseUrl";
import {MDBContainer,} from "mdb-react-ui-kit";
import {styled} from "@mui/material/styles";
import {useParams} from "react-router-dom";
import BackServer from "../../api/BackServer";
import Box from "@mui/material/Box";
import OneProductGlass from "../OneProductShort/OneProductGlass";
import BackGround from "../BackGround/BackGround";
// import "./ecommerce-category-product.css";



const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const MyCart = (props) => {
    const params = useParams();

    const [products, setProducts] = useState([])
    const [category, setCategory] = useState([])
    const [sum, setSum] = useState([])
    const [summWeight, setSummWeight]=useState(0)

    const getProducts = async () => {
        var favor= JSON.parse( localStorage.getItem('cart'))
        await BackServer.GetCart(favor).then(u => {
            if (u) {
               // console.log(u)
                setSum(u.message.Products.category.Cost)
                setSummWeight(u.message.Products.category.Weight)
                setProducts(u.message.Products.lst)
                setCategory(u.message.Products.category)
            }
        })}


    const callup = (len) => {
        getProducts()
        props.callbackX(len)
    }

    useEffect(() => {
        getProducts()
    }, [])



    return (
            <>
            {/*<Categories/>*/}
            {/*<a>ПРОДУКТЫ</a>*/}
            {/*<a>{category_id}</a>*/}
            {/*<Filters/>*/}
            <Box sx={{ width: '100%' }}>
                <Stack spacing={1}>
                    <MDBContainer fluid >
                        {products.map((elm, key) => (
                            <OneProductGlass key={key}   callbak={callup} elm={elm} label={elm.name} img={baseUrl_back+elm.imageUrl}  urlx={elm.Url} />
                        ))}
                    </MDBContainer>
                    {products.length > 0?
                        <>
                            <MDBContainer fluid className={"tst"} >
                                <div className={"tst"}>
                                    <h5>Вес: {summWeight} гр</h5>
                                </div>
                            </MDBContainer>
                            <MDBContainer fluid className={"tst"} >
                                <div className={"tst"}>
                                    <h5>Сумма: {sum} ₽</h5>
                                </div>
                            </MDBContainer>

                            <Box sx={{ mb: 2 }}>
                                <div>

                                    <Button
                                        variant="contained"
                                        onClick={props.callNext}
                                        sx={{ mt: 1, mr: 1 }}
                                    >
                                        Перейти к доставке
                                    </Button>
                                </div>
                            </Box>
                        </> : <a>Ваша корзина пуста</a> }



                </Stack>
            </Box>
            <BackGround/>
            </>

    );
};

export default MyCart;